import { Injectable } from '@angular/core';
import { timer } from 'rxjs';
import ms from 'ms';
import { difference, momentInstance } from 'src/app/modules/core/services/datetime.service';
import { environment } from 'src/environments/environment';
import { tap, takeLast } from 'rxjs/operators';
import { Parameter } from 'projects/common/src/app/classes';

@Injectable({
  providedIn: 'root'
})
export class DayService extends Parameter<string> {

  constructor() {
    super();
    this.name = 'date';
  }

  public start(): Promise<string> {
    return new Promise((resolve) => {
      const timeForTomorrow = this.timeForTomorrow();
      this.log(`Next day start in ${ms(timeForTomorrow, { long: true })}`);
      this.set(this.currentTime());
      timer(timeForTomorrow, ms('24h')).pipe(
        tap(() => this.set(this.currentTime()))
      ).subscribe();
      resolve(this.currentTime());
    });
  }

  private currentTime(): string {
    const date = momentInstance(new Date()).format(environment.dateFormatSystem);
    return date;
  }

  private timeForTomorrow(): number {
    const now = momentInstance();
    const tomorrow = now.add(1, 'day').startOf('day');
    const diff = difference(tomorrow);
    return Math.abs(diff);
  }
}
